/** @format */

export const ADD_ACTIVITIES_REQUEST = "ADD_ACTIVITIES_REQUEST";
export const ADD_ACTIVITIES_SUCCESS = "ADD_ACTIVITIES_SUCCESS";
export const ADD_ACTIVITIES_FAILURE = "ADD_ACTIVITIES_FAILURE";
